import Section from 'Components/ContractGenerator/layouts/Section';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { contractGeneratorOperations, contractGeneratorSelectors } from 'Redux/ducks/contractGenerator';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';
import Spacer from 'ViatoUi/Shared/Layouts/Spacer';

import styles from './PaymentType.module.scss';

const PaymentType = () => {
	const dispatch = useDispatch();
	const { t } = useTranslation('contractGenerator');

	const { MONTHLY_PAYMENT_PRICE_MULTIPLICATOR } = useSelector(contractGeneratorSelectors.getConstants);
	const { selectedPaymentType } = useSelector(contractGeneratorSelectors.getDataToSubmit);

	return (
		<Section headline={t('pages.step2.paymentType.headline')}>
			<FlexBox alignItems='center' flexDirection='column'>
				<strong>{t('pages.step2.paymentType.howToPay')}</strong>
				<Spacer height='m' />
				<div className={styles.toggle}>
					<div
						className={styles.option}
						data-selected={selectedPaymentType === 'monthly'}
						role='button'
						tabIndex={0}
						onClick={() => dispatch(contractGeneratorOperations.setDataToSubmit({ selectedPaymentType: 'monthly' }))}
					>
						{t('pages.step2.paymentType.monthly')}
					</div>
					<div
						className={styles.option}
						data-selected={selectedPaymentType === 'yearly'}
						role='button'
						tabIndex={0}
						onClick={() => dispatch(contractGeneratorOperations.setDataToSubmit({ selectedPaymentType: 'yearly' }))}
					>
						{t('pages.step2.paymentType.yearly')}
					</div>
					<div className={styles.discount}>
						{t('pages.step2.paymentType.discount', { amount: MONTHLY_PAYMENT_PRICE_MULTIPLICATOR * 100 })}
					</div>
				</div>
			</FlexBox>
			<Spacer height='s' />
			<Spacer height='l' />
		</Section>
	);
};

export default PaymentType;
